/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-07-01 15:03:06
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-13 11:34:56
 */
import axios from 'axios'
import {message} from 'antd'
import store from '../../../../../store'
import moment from 'moment'

const url = window.url ? window.url.order : null;
const productUrl = window.url ? window.url.getProductInspectionOrder : null;

/**
 * 分页查询下载订单
 * @returns
 */
export async function getOrderDownload(page = 1, limit = 10, userId = '', orderId = '', startTime, endTime, token) {
    // console.log(userId)
    let query = url + '/order/download/page' + '?userId=' + userId + '&page=' + page + '&limit=' + limit + '&orderId=' + orderId;
    if (startTime) query += `&fromTime=${moment(startTime).format("YYYY-MM-DD HH:mm:ss")}`
    if (endTime) query += `&endTime=${moment(endTime).format("YYYY-MM-DD HH:mm:ss")}`
    return new Promise((resolve, reject) => {
        axios.get(query, {
            headers: {
                'Authorization': token
            }
        }).then((res) => {
            // console.log('ceshi12', res)
            resolve(res.data.payload)
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 获取微波仿真订单
 * @param {string} orderid
 * @returns {Promise<void>}
 */
export async function getOpticalSarSim(orderid){
    return new Promise((resolve, reject) => {
        axios.get(`${global.gatewayip}/api/interface/api/getOpticalSarSim?orderid=${orderid}`).then((res) => {
            // console.log('ceshi12', res)
            resolve(res.data.data)
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 获取数据下载链接
 * @param {string} dataName
 * @param {string} dataType
 * @param {string} userId
 * @returns {Promise<unknown>}
 */
export async function getDataDownloadURL(dataName,dataType,userId){
    return new Promise((resolve, reject) => {
            axios.post(`${global.gatewayip}/api/interface/api/getDownloadDataURL?dataName=${dataName}&dataType=${dataType}&priority=1&userId=${userId}`)
                .then((res) => {
                    // console.log('微波仿真数据', res)
                    if (res.data.code === "0") {
                        resolve(res.data)
                    } else {
                        reject('获取数据失败',res.data.info)
                    }
                }).catch((e) => {
                reject(e)
            })
        }
    )
}

/**
 * 分页查询上传订单
 * @returns
 */
export async function getOrderUpload(page = 1, limit = 10, userId = '', orderId = '', startTime, endTime) {
    let query = url + `/order/issue/issue/page?limit=${limit}&page=${page}&userId=${userId}`
    if (startTime) query += `&fromTime=${moment(startTime).format("YYYY-MM-DD HH:mm:ss")}`
    if (endTime) query += `&endTime=${moment(endTime).format("YYYY-MM-DD HH:mm:ss")}`
    if (orderId !== '') query += `&orderId=${orderId}`
    return new Promise((resolve, reject) => {
        axios.get(query).then((res) => {
            console.log('ceshi12', res)
            if (res.data.code === '200') {
                resolve(res.data.payload)
            } else {
                reject('获取数据失败')
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 分页查询生产订单
 * @returns
 */
export async function getOrderData(page = 1, limit = 10, userId = '', parentOrderID = '', satStartDate, satEndDate, userName) {
    // http://192.168.158.13:9527/api/order-service/order/search/myproductionorder?limit=1&orderCreationUserId=1&page=1
    // debugger
    // let query = `${url}/order/search/production/page?limit=${limit}&userId=${userId}&page=${page}&orderId=${orderId}`;
    // let query = `${global.yunguanGetOrder}/dispatch/pageList?pageSize=${limit}&pagenum=${page}`;
    // let query = `http://10.0.36.105:9094/dispatch/pageList?pageSize=1&pagenum=1`
    let query = `/yunguanGetOrder/dispatch/pageList1?pageSize=${limit}&pagenum=${page}&orderSource=共性技术集成与共享分系统&orderType=产品生产订单`
    if (parentOrderID && parentOrderID !== '') query += `&parentOrderID=${parentOrderID}`
    if (userName && userName !== '') query += `&operator=${userName}`
    if (satStartDate) {
        query += `&satStartDate=${moment(satStartDate).format("yyyy-MM-DD")}`
        query += ` 00:00:00`
    }
    if (satEndDate) {
        query += `&satEndDate=${moment(satEndDate).format("yyyy-MM-DD")}`
        query += ` 00:00:00`

    }
    return new Promise((resolve, reject) => {
        axios.get(query).then((res) => {
            console.log('ceshi12', res)

            let sendData = {...res.data.data};
            console.log("sendData", sendData);
            sendData.rows && sendData.rows.map((item) => {
                item.orderId = item.parentOrderID;
                item.page = item.pagenum;
            })
            if (res.data.code === 200) {
                resolve(sendData)
            } else {
                reject('获取数据失败')
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 获取微波仿真订单数据
 * @param page
 * @param limit
 * @param userId
 * @param orderId
 * @param startTime
 * @param endTime
 * @returns {Promise<void>}
 */
export async function getMicrowaveData(page = 1, limit = 10, userId = '', orderId = '', startTime = null, endTime = null) {
    let submitStartTime = `${moment(startTime).format("yyyy-MM-DD")} 00:00:00`;
    let submitEndTime = `${moment(endTime).format("yyyy-MM-DD")} 00:00:00`;
    let sendData = {
        orderID: orderId,
        userId: userId,
        pagenum: page,
        count: limit,
    }
    if (startTime) sendData.orderSubmitStartTime = submitStartTime;
    if (endTime) sendData.orderSubmitEndTime = submitEndTime;
    let formData = new FormData();
    for (let i in sendData) {
        formData.append(i, sendData[i]);
    }
    return new Promise((resolve, reject) => {
            // axios.post(`https://caplos.aircas.ac.cn/gateway/api/interface/ddtc/dealManage/wbfzddSearch`, formData)
            axios.post(global.url.interfaceUrl2 + `/ddtc/dealManage/wbfzddSearch`, formData)
                .then((res) => {
                    // console.log('微波仿真数据', res)
                    if (res.data.msg === "SUCCESS") {
                        resolve(res.data)
                    } else {
                        reject('获取数据失败')
                    }
                }).catch((e) => {
                reject(e)
            })
        }
    )
}

/**
 * 个人中心-仿真订单提交
 * @param microwaveOrder<object> 包含后端需要提交的各个字段的对象
 * @returns {Promise<object>}
 */
export async function putMicrowaveOder(microwaveOrder) {
    let sendData = microwaveOrder;
    return new Promise((resolve, reject) => {
        axios.post(global.url.interfaceUrl2 + `/ddtc/managedeal/wbfzdd/detailreceive`, sendData)
            .then((res) => {
                // console.log('微波仿真数据提交结果', res,res.data.code === 0)
                if (res.data.code === 0) {
                    // console.log('微波仿真数据提交结果', res.data,res.data.code === 0)
                    resolve(res.data)
                } else {
                    reject('数据获取失败')
                }
            }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 分页查询仿真订单
 * @returns
 */
export async function getSimulationData(page = 1, limit = 10, userId = '', orderId = '', startTime, endTime) {
    let submitStartTime = `${moment(startTime).format("yyyy-MM-DD")} 00:00:00`;
    let submitEndTime = `${moment(endTime).format("yyyy-MM-DD")} 00:00:00`;
    let sendData = {
        orderID: orderId,
        userId: userId,
        // orderStatus:"",
        // orderType: "算法检验订单",
        pagenum: page,
        count: limit,
        // orderSubmitStartTime: startTime,
        // orderSubmitEndtime: endTime,
    }
    if (startTime) sendData.orderSubmitStartTime = submitStartTime;
    if (endTime) sendData.orderSubmitEndTime = submitEndTime;
    let formData = new FormData();
    for (let i in sendData) {
        formData.append(i, sendData[i]);
    }
    // ?userId=${userId}&pageNum=${page}&pageSize=${limit}&keyword=${orderId}&startTime=${startTime}&endTime=${endTime}
    return new Promise((resolve, reject) => {
        axios.post(`/yunguanUploadOrder/ddtc/dealManage/fzddSearch`, formData)
            .then((res) => {
                console.log('ceshi12', res)
                if (res.data.msg === "SUCCESS") {
                    resolve(res.data)
                } else {
                    reject('获取数据失败')
                }
            }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 分页查询未来订单
 * @returns
 */
export async function getOrderProduction(page, limit) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/order/search/production/page' + '?page=' + page + '&limit=' + limit).then((res) => {
            resolve(res.data.payload)
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 分页查询未来订单
 * @returns
 */
export async function getOrderProduction_text(page = 1, limit = 10, userId = '', parentOrderID = '', satStartDate, satEndDate, userName) {
    let query = `/yunguanGetOrder/dispatch/pageList1?pageSize=${limit}&pagenum=${page}&orderSource=共性技术集成与共享分系统&orderType=未来订单`
    if (parentOrderID && parentOrderID !== '') query += `&parentOrderID=${parentOrderID}`
    if (userName && userName !== '') query += `&operator=${userName}`
    if (satStartDate) {
        query += `&satStartDate=${moment(satStartDate).format("yyyy-MM-DD")}`
        query += ` 00:00:00`
    }
    if (satEndDate) {
        query += `&satEndDate=${moment(satEndDate).format("yyyy-MM-DD")}`
        query += ` 00:00:00`

    }
    return new Promise((resolve, reject) => {
        axios.get(query).then((res) => {
            // console.log('ceshi12', res)

            let sendData = {...res.data.data};
            // console.log("检查未来订单数据:", sendData);
            sendData.rows && sendData.rows.map((item) => {
                item.orderId = item.parentOrderID;
                item.page = item.pagenum;
            })
            if (res.data.code === 200) {
                resolve(sendData)
            } else {
                reject('获取数据失败')
            }
        }).catch((e) => {
            reject(e)
        })
    })
    // return new Promise((resolve, reject) => {
    //     let data = {
    //         "total": 6,
    //         "records": [
    //             {
    //                 "algIds": "1,2,5",
    //                 "flowId": "AOD",
    //                 "flowXmlPath": "2",
    //                 "isurged": false,
    //                 "key": "1",
    //                 "orderCreationTime": "2021-10-22T15:37:33",
    //                 "orderCreationUserId": "1",
    //                 "orderFinishTime": "2021-12-20T15:38:15",
    //                 "orderId": "1",
    //                 "orderResultCacheAddr": "aaa",
    //                 "orderResultPath": "",
    //                 "orderStatus": "进行中",
    //                 "orderStep": 1,
    //                 "rawDataName": "清风",
    //                 "rawDataPath": "group2/M00/00/03/rBMAFmF_kkyAQ3LmAAA3sL0rLWw75.docx",
    //                 "rawDataSize": "135kb",
    //                 "rawDataUploadTime": "2020-11-11",
    //                 "statusDescribe": "进行中",
    //                 "statusUpdateTime": "2021-10-20T15:37:30",
    //                 "childrenFinishCount": 2,
    //                 "childrenConductCount": 1,
    //                 "childrenUntreatedCount": 2,
    //                 "childrenFailCount": 0,
    //                 "childrenAllCount": 5,
    //                 "isSending": true,
    //                 "orderChildren": [
    //                     {
    //                         "name": "卫星数据1",
    //                         "status": "已完成",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据2",
    //                         "status": "已完成",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据3",
    //                         "status": "处理中",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据4",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据5",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "algIds": "1,2,5",
    //                 "flowId": "AOD",
    //                 "flowXmlPath": "2",
    //                 "isurged": false,
    //                 "key": "2",
    //                 "orderCreationTime": "2021-10-22T15:37:33",
    //                 "orderCreationUserId": "2",
    //                 "orderFinishTime": "2021-12-15T15:38:15",
    //                 "orderId": "2",
    //                 "orderResultCacheAddr": "aaa",
    //                 "orderResultPath": "",
    //                 "orderStatus": "进行中",
    //                 "orderStep": 1,
    //                 "rawDataName": "清风",
    //                 "rawDataPath": "group2/M00/00/03/rBMAFmF_kkyAQ3LmAAA3sL0rLWw75.docx",
    //                 "rawDataSize": "135kb",
    //                 "rawDataUploadTime": "2020-11-11",
    //                 "statusDescribe": "进行中",
    //                 "statusUpdateTime": "2021-10-20T15:37:30",
    //                 "childrenFinishCount": 0,
    //                 "childrenConductCount": 0,
    //                 "childrenUntreatedCount": 4,
    //                 "childrenFailCount": 1,
    //                 "childrenAllCount": 5,
    //                 "isSending": true,
    //                 "orderChildren": [
    //                     {
    //                         "name": "卫星数据1",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据2",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据3",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据4",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据5",
    //                         "status": "推送失败",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "algIds": "1,2,5",
    //                 "flowId": "AOD",
    //                 "flowXmlPath": "2",
    //                 "isurged": false,
    //                 "key": "3",
    //                 "orderCreationTime": "2021-10-22T15:37:33",
    //                 "orderCreationUserId": "3",
    //                 "orderFinishTime": "2021-12-18T15:38:15",
    //                 "orderId": "3",
    //                 "orderResultCacheAddr": "aaa",
    //                 "orderResultPath": "",
    //                 "orderStatus": "进行中",
    //                 "orderStep": 1,
    //                 "rawDataName": "清风",
    //                 "rawDataPath": "group2/M00/00/03/rBMAFmF_kkyAQ3LmAAA3sL0rLWw75.docx",
    //                 "rawDataSize": "135kb",
    //                 "rawDataUploadTime": "2020-11-11",
    //                 "statusDescribe": "进行中",
    //                 "statusUpdateTime": "2021-10-20T15:37:30",
    //                 "childrenFinishCount": 2,
    //                 "childrenConductCount": 0,
    //                 "childrenUntreatedCount": 3,
    //                 "childrenFailCount": 0,
    //                 "childrenAllCount": 5,
    //                 "isSending": true,
    //                 "orderChildren": [
    //                     {
    //                         "name": "卫星数据1",
    //                         "status": "已完成",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据2",
    //                         "status": "已完成",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据3",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据4",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据5",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "algIds": "1,2,5",
    //                 "flowId": "AOD",
    //                 "flowXmlPath": "2",
    //                 "isurged": false,
    //                 "key": "4",
    //                 "orderCreationTime": "2021-10-22T15:37:33",
    //                 "orderCreationUserId": "4",
    //                 "orderFinishTime": "2021-11-20T15:38:15",
    //                 "orderId": "4",
    //                 "orderResultCacheAddr": "aaa",
    //                 "orderResultPath": "",
    //                 "orderStatus": "进行中",
    //                 "orderStep": 1,
    //                 "rawDataName": "清风",
    //                 "rawDataPath": "group2/M00/00/03/rBMAFmF_kkyAQ3LmAAA3sL0rLWw75.docx",
    //                 "rawDataSize": "135kb",
    //                 "rawDataUploadTime": "2020-11-11",
    //                 "statusDescribe": "进行中",
    //                 "statusUpdateTime": "2021-10-20T15:37:30",
    //                 "childrenFinishCount": 2,
    //                 "childrenConductCount": 1,
    //                 "childrenUntreatedCount": 2,
    //                 "childrenFailCount": 0,
    //                 "childrenAllCount": 5,
    //                 "isSending": false,
    //                 "orderChildren": [
    //                     {
    //                         "name": "卫星数据1",
    //                         "status": "已完成",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据2",
    //                         "status": "已完成",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据3",
    //                         "status": "处理中",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据4",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据5",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "algIds": "1,2,5",
    //                 "flowId": "AOD",
    //                 "flowXmlPath": "2",
    //                 "isurged": false,
    //                 "key": "5",
    //                 "orderCreationTime": "2021-10-22T15:37:33",
    //                 "orderCreationUserId": "5",
    //                 "orderFinishTime": "2021-11-15T15:38:15",
    //                 "orderId": "5",
    //                 "orderResultCacheAddr": "aaa",
    //                 "orderResultPath": "",
    //                 "orderStatus": "已完成",
    //                 "orderStep": 1,
    //                 "rawDataName": "清风",
    //                 "rawDataPath": "group2/M00/00/03/rBMAFmF_kkyAQ3LmAAA3sL0rLWw75.docx",
    //                 "rawDataSize": "135kb",
    //                 "rawDataUploadTime": "2020-11-11",
    //                 "statusDescribe": "已完成",
    //                 "statusUpdateTime": "2021-10-20T15:37:30",
    //                 "childrenFinishCount": 3,
    //                 "childrenConductCount": 0,
    //                 "childrenUntreatedCount": 2,
    //                 "childrenFailCount": 0,
    //                 "childrenAllCount": 5,
    //                 "isSending": false,
    //                 "orderChildren": [
    //                     {
    //                         "name": "卫星数据1",
    //                         "status": "已完成",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据2",
    //                         "status": "已完成",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据3",
    //                         "status": "已完成",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据4",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据5",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "algIds": "1,2,5",
    //                 "flowId": "AOD",
    //                 "flowXmlPath": "2",
    //                 "isurged": false,
    //                 "key": "6",
    //                 "orderCreationTime": "2021-10-22T15:37:33",
    //                 "orderCreationUserId": "6",
    //                 "orderFinishTime": "2021-11-05T15:38:15",
    //                 "orderId": "6",
    //                 "orderResultCacheAddr": "aaa",
    //                 "orderResultPath": "",
    //                 "orderStatus": "已截止",
    //                 "orderStep": 1,
    //                 "rawDataName": "清风",
    //                 "rawDataPath": "group2/M00/00/03/rBMAFmF_kkyAQ3LmAAA3sL0rLWw75.docx",
    //                 "rawDataSize": "135kb",
    //                 "rawDataUploadTime": "2020-11-11",
    //                 "statusDescribe": "已截止",
    //                 "statusUpdateTime": "2021-10-20T15:37:30",
    //                 "childrenFinishCount": 0,
    //                 "childrenConductCount": 0,
    //                 "childrenUntreatedCount": 5,
    //                 "childrenFailCount": 0,
    //                 "childrenAllCount": 5,
    //                 "isSending": false,
    //                 "orderChildren": [
    //                     {
    //                         "name": "卫星数据1",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据2",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据3",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据4",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     },
    //                     {
    //                         "name": "卫星数据5",
    //                         "status": "待处理",
    //                         "sendTime": "2021-11-02T12:15:15"
    //                     }
    //                 ]
    //             }
    //         ]
    //     };
    //     data.records.map((d) => {
    //         d.startAndEndTime = d.orderCreationTime.split("T")[0] + " - " + d.orderFinishTime.split("T")[0];
    //         d.startTime = d.orderCreationTime.split("T")[0];
    //         d.childrenRecordCount = "(" + d.childrenConductCount + "+" + d.childrenFinishCount + ")/" + d.childrenAllCount;
    //     })
    //     resolve(data)
    //     // axios.get("data/我的订单/未来订单/order.json").then((res) => {
    //     //     let data = res.data;
    //     //     data.records.map((d) => {
    //     //         d.startAndEndTime = d.orderCreationTime.split("T")[0] + " - " + d.orderFinishTime.split("T")[0];
    //     //         d.startTime = d.orderCreationTime.split("T")[0];
    //     //         d.childrenRecordCount = "(" + d.childrenConductCount + "+" + d.childrenFinishCount + ")/" + d.childrenAllCount;
    //     //     })
    //     //     // console.log("data",data);
    //     //     resolve(data)
    //     // }).catch((e) => {
    //     //     reject(e)
    //     // })
    // })
}

/**
 * 下载订单 获取订单下载url
 * @returns 订单url
 */
export async function downloadOrder(orderId) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/order/download/getUrl?orderId=' + orderId).then((res) => {
            resolve(res.data.payload)
        }).catch((e) => {
            reject(e)
        })
    })
}

export async function downloadOrderBychild(id) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/order/download/getUrl?id=' + id).then((res) => {
            resolve(res.data.payload)
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 分页查询当前用户产品检验订单
 * @param {当前用户编号userId} userId
 * @param {关键字查询，订单编号orderId} orderId
 * @param {关键字查询，订单开始时间startTime} startTime
 * @param {关键字查询，订单结束时间endTime} endTime
 */
export async function getProductInspectionOrder(page = 1, limit = 10, userId = '', orderId = '', startTime, endTime) {
    // return new Promise((resolve, reject) => {
    //     axios.get(productUrl + `/outside/order/queryUserCenterOrderList?userId=${userId}&pageNum=${page}&pageSize=${limit}&keyword=${orderId}&startTime=${startTime}&endTime=${endTime}`)
    //         .then((res) => {
    //             console.log(res)
    //             let sendData = { ...res.data }
    //             if (res.data.success) {
    //                 async function text(orderDetail) {
    //                     let res2 = await getProductInspectionOrderDetails(orderDetail.orderCode)
    //                     console.log('2',res2)
    //                     if (!res2) {
    //                         return null;
    //                     } else {
    //                         if (!res2.data.validationReport) return null;
    //                         return res2.data.validationReport.validationReportDownload;
    //                     }
    //                 }
    //                 let count = 0;
    //                 let maxCount = sendData.data.list && sendData.data.list.length;
    //                 sendData.data.list.map((orderDetail) => {
    //                     async function name() {
    //                         orderDetail.url = await text(orderDetail);
    //                         count += 1;
    //                     }
    //                     name();
    //                 })
    //                 let nowTimer = 0;
    //                 let timerCount = 500;
    //                 let maxTimerCount = 10000;
    //                 let timer = setInterval(() => {
    //                     if (count === maxCount) {
    //                         resolve(sendData);
    //                         clearInterval(timer);
    //                     }
    //                     nowTimer += timerCount;
    //                     if (nowTimer >= maxTimerCount) {
    //                         message.error('产品检验订单信息获取失败！');
    //                         clearInterval(timer);
    //                     }
    //                 }, timerCount);
    //             }
    //         }).catch((e) => {
    //             reject(e)
    //         })
    // })
    return new Promise((resolve, reject) => {
        axios.get(productUrl + `/outside/order/queryUserCenterOrderList?userId=${userId}&pageNum=${page}&pageSize=${limit}&keyword=${orderId}&startTime=${startTime}&endTime=${endTime}`)
            .then(res => {
                console.log('ceshi12', res)
                if (res.data.code === 200) {
                    resolve(res.data.data)
                } else {
                    reject(res.data.message)
                }
            }).catch(err => {
            reject(err)
        })
    })
}

// 技术检验检索接口
export async function getTechnologyInspectionOrder(page = 1, limit = 10, userId = '', orderId = '', startTime, endTime) {
    let sendData = {
        orderID: orderId,
        userId: userId,
        // orderStatus:"任务完成",
        // orderType: "算法检验订单",
        pagenum: page,
        count: limit,
    }
    let formData = new FormData();
    for (let i in sendData) {
        formData.append(i, sendData[i]);
    }
    // ?userId=${userId}&pageNum=${page}&pageSize=${limit}&keyword=${orderId}&startTime=${startTime}&endTime=${endTime}
    // ddtc/dealManage/sfjySearch
    return new Promise((resolve, reject) => {
        axios.post(`/yunguanUploadOrder/ddtc/dealManage/sfjySearch`, formData)
            .then((res) => {
                console.log('ceshi12', res)
                if (res.data.msg === "SUCCESS") {
                    resolve(res.data)
                } else {
                    reject('获取数据失败')
                }
            }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 根据产品检验订单编号查询订单详情
 * @param {订单编号} orderId
 */
export async function getProductInspectionOrderDetails(orderId) {
    return new Promise((resolve, reject) => {
        axios.get(productUrl + `/outside/order/queryOrderInfo?orderCode=${orderId}`)
            .then((res) => {
                resolve(res.data)
            }).catch((e) => {
            reject(e)
        })
    })
}


/**
 * 根据技术检验订单编号重新检验
 * @param {订单编号} ordercode
 */
export async function getTechnicalInspectionOrderReExameOrder(ordercode) {
    let sendData = {
        ordercode: ordercode,
    }
    return new Promise((resolve, reject) => {
        axios.post(`/gxpt/algorithm/anewCheckout`, sendData)
            .then((res) => {
                resolve(res.data)
            }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 根据技术检验订单编号重新提交
 * @param {订单编号} ordercode
 */
export async function getTechnicalInspectionOrderReSubmitOrder(ordercode) {
    let sendData = {
        ordercode: ordercode,
    }
    return new Promise((resolve, reject) => {
        axios.post(`/gxpt/algorithm/anewAddAlgorithm`, sendData)
            .then((res) => {
                resolve(res.data)
            }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 获取产品名
 * @param productType 产品类型(六大类)
 * @param dataType 数据共享会议[南京,文昌,包头,首批]
 * @returns {Promise<unknown>}
 */
export async function getBTProductName(productType, dataType) {
    return new Promise(
        (resolve, reject) => {
            axios.get(global.url.demo + `/btdata/getproductname?dataType=${dataType}&productType=${productType}`)
                .then(res => {
                    if (res.data.code === '200' && res.data) {
                        resolve(res.data);
                    } else {
                        reject(new Error('Invalid response'));
                    }
                }).catch((e) => {
                reject(e)
            })
        }
    )
}

/**
 * 获取站点名称
 * @param productType 产品类型
 * @param productName 产品名称
 * @param dataType 数据共享会议[南京,文昌,包头,首批]
 * @returns {Promise<unknown>}
 */
export async function getSiteNames(productType, productName, dataType) {
    return new Promise(
        (resolve, reject) => {
            axios.get(global.url.demo + `/btdata/getsitename?productName=${productName}&productType=${productType}&dataType=${dataType}`)
                .then(res => {
                    if (res.data.code === '200' && res.data) {
                        resolve(res.data);
                    } else {
                        reject(new Error('Invalid response'));
                    }
                }).catch((e) => {
                reject(e)
            })
        }
    )
}

/**
 * 筛选查询包头会议共享数据
 * @param productType
 * @param productName
 * @param dataType
 * @param siteName
 * @returns {Promise<unknown>}
 */
export async function getBTData(productType, productName, dataType, siteName) {
    return new Promise(
        (resolve, reject) => {
            axios.get(global.url.demo + `/btdata/get?productName=${productName}&productType=${productType}&dataType=${dataType}&siteName=${siteName}`)
                .then(res => {
                    if (res.data.code === '200' && res.data) {
                        resolve(res.data);
                    } else {
                        reject(new Error('Invalid response'));
                    }
                }).catch((e) => {
                reject(e)
            })
        }
    )
}

/**
 * 提交下载订单记录
 * @param downloadOder
 * @returns {Promise<unknown>}
 */
export async function putDownloadOderRecords(downloadOder) {
    let sendData = downloadOder;
    return new Promise((resolve, reject) => {
        axios.post(global.url.order + `/order/download/save1`, sendData)
            .then((res) => {
                if (res.data.code === '200') {
                    resolve(res.data)
                } else {
                    reject('下载订单提交失败')
                }
            }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 获取仿真卫星数据
 * @returns {Promise<unknown>}
 */
export async function getAllSimulationData() {
    return new Promise(
        (resolve, reject) => {
            axios.get(global.url.demo + `/simulation/getSimulationData`)
                .then(res => {
                    if (res.data.code === '200' && res.data) {
                        resolve(res.data);
                    } else {
                        reject(new Error('Invalid response'));
                    }
                }).catch((e) => {
                reject(e)
            })
        }
    )
}

